import React from 'react';

import { formatFigure } from 'Helpers/formatService';

import Tooltip from 'CommonComponents/Tooltip';

export default function RevenueMilestoneFields(props) {
    const tooltipContent = () => {
        return props.revenue && props.revenue.currentMilestones[props.milestoneId] ? props.revenue.currentMilestones[props.milestoneId].name : '';
    };

    const hasMilestone = props.milestoneId in props.revenue.currentMilestones && props.revenue.currentMilestones[props.milestoneId];

    const hasPercentage = hasMilestone && typeof props.revenue.currentMilestones[props.milestoneId].percentage !== 'undefined';

    // Check if this cell should be in row editing mode
    const isInRowEditMode = props.isRowEditing;
    const currentEditValue =
        props.editedValues && props.editedValues[props.milestoneId] !== undefined
            ? props.editedValues[props.milestoneId]
            : hasPercentage
              ? Math.round(Number(props.revenue.currentMilestones[props.milestoneId].percentage) * 100) / 100
              : '';

    // Calculate live amount during editing
    const getLiveAmount = () => {
        if (!isInRowEditMode || !props.totalUncommittedValue) return 0;

        const percentage = parseFloat(currentEditValue);
        if (isNaN(percentage) || percentage <= 0) return 0;

        return (props.totalUncommittedValue * percentage) / 100;
    };

    const liveAmount = isInRowEditMode ? getLiveAmount() : hasMilestone ? props.revenue.currentMilestones[props.milestoneId].amount : 0;

    return (
        <>
            {/* Percentage column - always render */}
            <td className="tw-text-right"></td>

            {/* Amount column */}
            <td className="tw-text-right">
                {isNaN(liveAmount) ? (
                    <span>0</span>
                ) : (
                    <Tooltip
                        placement="bottom-start"
                        tooltipContent={tooltipContent()}
                        backgroundClass="tw-bg-blue"
                        tooltipType="text"
                        allowTooltip={hasMilestone}
                    >
                        <span>{formatFigure(liveAmount)}</span>
                    </Tooltip>
                )}
            </td>
        </>
    );
}
